module.exports = {
  id: 40,
  name: 'Diamond Push-ups',
  categories: ['strength', 'arms', 'core'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'advanced',
  skill: 'Strength',
  points: 24,
  instructions:
    'Diamond push-ups are challenging! Put your hands in a diamond shape and do push-ups! This builds incredible arm and chest strength! Ready to try it?',
  timedInstructions: [
    {
      time: 0,
      text: "Let's do diamond push-ups! Get into plank position!",
    },
    {
      time: 2,
      text: 'Put your hands together in a diamond shape!',
    },
    {
      time: 4,
      text: 'Keep your body straight, feet together!',
    },
    {
      time: 6,
      text: 'Feel it in your chest and triceps! 3, 2, 1, START!',
    },
    // SET 1 - 10 reps
    {
      time: 9,
      text: 'Lower down, chest to your hands!',
    },
    {
      time: 11,
      text: 'Push up, feel your chest and arms working!',
    },
    {
      time: 13,
      text: 'Lower down, control the movement with strength!',
    },
    {
      time: 15,
      text: 'Push up, diamond hands strong and powerful!',
    },
    {
      time: 17,
      text: 'Lower down, feel your triceps working hard!',
    },
    {
      time: 19,
      text: 'Push up, chest and arms working together!',
    },
    {
      time: 21,
      text: 'Lower down, maintain perfect diamond position!',
    },
    {
      time: 23,
      text: 'Push up, feel the incredible strength building!',
    },
    {
      time: 25,
      text: 'Lower down, control it with perfect form!',
    },
    {
      time: 27,
      text: 'Push up, chest and triceps working as one!',
    },
    {
      time: 29,
      text: 'Lower down, body straight and strong!',
    },
    {
      time: 31,
      text: 'Push up, diamond hands strong and steady!',
    },
    {
      time: 33,
      text: 'Lower down, feel the burn and get stronger!',
    },
    {
      time: 35,
      text: 'Push up, keep your body in a perfect straight line!',
    },
    {
      time: 37,
      text: 'Lower down, keep your hands in perfect diamond shape!',
    },
    {
      time: 39,
      text: 'Push up, keep your core engaged and powerful!',
    },
    {
      time: 41,
      text: 'Lower down, feel your chest and arms working!',
    },
    {
      time: 43,
      text: 'Push up, incredible strength and power!',
    },
    {
      time: 45,
      text: 'Lower down, control the movement perfectly!',
    },
    {
      time: 47,
      text: 'Push up, you are a diamond master!',
    },
    // REST PERIOD - 15 seconds
    {
      time: 51,
      text: 'Awesome job! Take a good break now',
    },
    {
      time: 54,
      text: 'Breathe in and out, catch your breath',
    },
    {
      time: 57,
      text: "You just did 10 diamond push-ups, that's amazing!",
    },
    {
      time: 60,
      text: 'Your chest and arms are getting so strong!',
    },
    {
      time: 63,
      text: 'Remember to keep your hands in diamond shape',
    },
    {
      time: 66,
      text: 'Keep your body straight like a plank',
    },
    {
      time: 69,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 72,
      text: "You're building incredible strength!",
    },
    {
      time: 75,
      text: 'Ready for round two, diamond warrior!',
    },
    {
      time: 78,
      text: '3, 2, 1, KEEP GOING!',
    },
    // SET 2 - 10 reps
    {
      time: 81,
      text: 'Lower down, chest to diamond hands!',
    },
    {
      time: 83,
      text: 'Push up, feel your chest and arms working!',
    },
    {
      time: 85,
      text: 'Lower down, control the movement with strength!',
    },
    {
      time: 87,
      text: 'Push up, diamond hands strong and powerful!',
    },
    {
      time: 89,
      text: 'Lower down, feel your triceps working hard!',
    },
    {
      time: 91,
      text: 'Push up, chest and arms working together!',
    },
    {
      time: 93,
      text: 'Lower down, maintain perfect diamond position!',
    },
    {
      time: 95,
      text: 'Push up, feel the incredible strength building!',
    },
    {
      time: 97,
      text: 'Lower down, control it with perfect form!',
    },
    {
      time: 99,
      text: 'Push up, chest and triceps working as one!',
    },
    {
      time: 101,
      text: 'Lower down, body straight and strong!',
    },
    {
      time: 103,
      text: 'Push up, diamond hands strong and steady!',
    },
    {
      time: 105,
      text: 'Lower down, feel the burn and get stronger!',
    },
    {
      time: 107,
      text: 'Push up, keep your body in a perfect straight line!',
    },
    {
      time: 109,
      text: 'Lower down, keep your hands in perfect diamond shape!',
    },
    {
      time: 111,
      text: 'Push up, keep your core engaged and powerful!',
    },
    {
      time: 113,
      text: 'Lower down, feel your chest and arms working!',
    },
    {
      time: 115,
      text: 'Push up, incredible strength and power!',
    },
    {
      time: 117,
      text: 'Lower down, control the movement perfectly!',
    },
    {
      time: 119,
      text: 'Push up, you are a diamond master!',
    },
    // REST PERIOD 2 - 15 seconds
    {
      time: 123,
      text: 'Amazing work! Take another break',
    },
    {
      time: 126,
      text: 'Breathe deeply and feel your strength',
    },
    {
      time: 129,
      text: "You just did 20 diamond push-ups total! You're a beast! Incredible effort Champ!",
    },
    {
      time: 132,
      text: 'Your chest and arms are incredibly strong!',
    },
    {
      time: 135,
      text: 'Keep your form perfect for the final round',
    },
    {
      time: 138,
      text: 'Breathe and relax your muscles',
    },
    {
      time: 141,
      text: 'Ready for the final set, diamond champion!',
    },
    {
      time: 144,
      text: '3, 2, 1, FINAL ROUND!',
    },
    // SET 3 - 10 reps
    {
      time: 147,
      text: 'Lower down, chest to diamond hands!',
    },
    {
      time: 149,
      text: 'Push up, feel your chest and arms working!',
    },
    {
      time: 151,
      text: 'Lower down, control the movement with strength!',
    },
    {
      time: 153,
      text: 'Push up, diamond hands strong and powerful!',
    },
    {
      time: 155,
      text: 'Lower down, feel your triceps working hard!',
    },
    {
      time: 157,
      text: 'Push up, chest and arms working together!',
    },
    {
      time: 159,
      text: 'Lower down, maintain perfect diamond position!',
    },
    {
      time: 161,
      text: 'Push up, feel the incredible strength building!',
    },
    {
      time: 163,
      text: 'Lower down, control it with perfect form!',
    },
    {
      time: 165,
      text: 'Push up, chest and triceps working as one!',
    },
    {
      time: 167,
      text: 'Lower down, body straight and strong!',
    },
    {
      time: 169,
      text: 'Push up, diamond hands strong and steady!',
    },
    {
      time: 171,
      text: 'Lower down, feel the burn and get stronger!',
    },
    {
      time: 173,
      text: 'Push up, keep your body in a perfect straight line!',
    },
    {
      time: 175,
      text: 'Lower down, keep your hands in perfect diamond shape!',
    },
    {
      time: 177,
      text: 'Push up, keep your core engaged and powerful!',
    },
    {
      time: 179,
      text: 'Lower down, feel your chest and arms working!',
    },
    {
      time: 181,
      text: 'Push up, incredible strength and power!',
    },
    {
      time: 183,
      text: 'Lower down, control the movement perfectly!',
    },
    {
      time: 185,
      text: 'Push up, you are a diamond master!',
    },
    {
      time: 189,
      text: 'Incredible work! You did 30 diamond push-ups!',
    },
    {
      time: 192,
      text: 'Your chest and arms are incredibly strong!',
    },
    {
      time: 195,
      text: 'You are a diamond push-up champion!',
    },
  ],
};
